<template>
  <div class="gm-import-mapping">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div class="flex mb-4 gm-import-mapping__layout">
      <div class="w-full bg-white text-left gm-import-mapping__surface">
        <div class="flex border-b border-grey-500 p-4 gm-import-mapping__header">
          <div class="w-full">
            <p class="text-grey-700 font-semibold text-lg">
              {{ $t('frontend_groovemail_contacts_step2_match_imported') }}
            </p>
          </div>
        </div>
        <div class="flex mb-4 gm-import-mapping__table-wrap">
          <div class="w-full">
            <table role="table" class="table-fixed w-full gm-import-mapping__table">
              <thead role="rowgroup" class="gm-import-mapping__table-head">
                <tr role="row">
                  <th role="columnheader" scope="col" class="gm-import-mapping__column-heading">Imported value</th>
                  <th role="columnheader" scope="col" class="gm-import-mapping__column-heading">{{ $t('frontend_groovemail_contacts_step2_select_field') }}</th>
                </tr>
              </thead>
              <tbody role="rowgroup" v-if="this.localModel.created_contacts.length > 0">
                <tr
                  v-for="(value, index) in localModel.created_contacts[base_index].length"
                  :key="index"
                  role="row"
                  class="gm-import-mapping__row"
                >
                  <td role="cell" class="border-b border-grey-500 gm-import-mapping__value-cell">
                    <p
                      :id="'gm-import-mapping-value-' + base_index + '-' + index"
                      class="ml-4 text-grey-700 font-semibold text-md gm-import-mapping__value"
                    >
                      {{
                        localModel.created_contacts[base_index][index].value
                      }}
                    </p>
                  </td>
                  <td role="cell" class="border-b border-grey-500 py-4 px-8 gm-import-mapping__control-cell">
                    <label
                      :for="'gm-import-mapping-select-' + base_index + '-' + index"
                      class="gm-import-mapping__control-label"
                    >
                      {{ $t('frontend_groovemail_contacts_step2_select_field') }}
                    </label>
                    <select
                      :id="'gm-import-mapping-select-' + base_index + '-' + index"
                      :aria-describedby="'gm-import-mapping-value-' + base_index + '-' + index"
                      @change="
                        onChange(
                          $event,
                          localModel.created_contacts[base_index][index].id
                        )
                      "
                      class="w-full h-10 outline-none border border-grey-200 rounded-lg px-4 gm-import-mapping__select"
                      @click="onFocus($event)"
                      oldvalue=""
                    >
                      <option value="">
                        {{ $t('frontend_groovemail_contacts_step2_select_field') }}
                      </option>
                      <option value="Ignore">
                        {{ $t('frontend_groovemail_contacts_step2_ignore') }}
                      </option>
                      <option
                        value="first_name"
                        :disabled="
                          localModel.matchfields.includes('first_name')
                            ? true
                            : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_first_name') }}
                        </option
                      >
                      <option
                        value="last_name"
                        :disabled="
                          localModel.matchfields.includes('last_name') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_last_name') }}
                        </option
                      >
                      <option
                        value="email"
                        :disabled="
                          localModel.matchfields.includes('email') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_email_req') }}
                        </option
                      >
                      <option
                        value="phone_number"
                        :disabled="
                          localModel.matchfields.includes('phone_number')
                            ? true
                            : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_phone_number') }}
                        </option
                      >

                      <option
                        value="company"
                        :disabled="
                          localModel.matchfields.includes('company') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_company') }}
                        </option
                      >
                      <option
                        value="address_1"
                        :disabled="
                          localModel.matchfields.includes('address_1') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_address1') }}
                        </option
                      >
                      <option
                        value="address_2"
                        :disabled="
                          localModel.matchfields.includes('address_2') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_address2') }}
                        </option
                      >
                      <option
                        value="state"
                        :disabled="
                          localModel.matchfields.includes('state') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_state') }}
                        </option
                      >

                      <option
                        value="zip"
                        :disabled="
                          localModel.matchfields.includes('zip') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_zip') }}
                        </option
                      >
                      <option
                        value="url"
                        :disabled="
                          localModel.matchfields.includes('url') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_url') }}
                        </option
                      >
                      <option
                        value="tax_number"
                        :disabled="
                          localModel.matchfields.includes('tax_number')
                            ? true
                            : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_taxnumber') }}
                        </option
                      >
                      <option
                        value="billing_address"
                        :disabled="
                          localModel.matchfields.includes('billing_address')
                            ? true
                            : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_billing_address') }}
                        </option
                      >
                      <option
                        value="ip_address"
                        :disabled="
                          localModel.matchfields.includes('ip_address')
                            ? true
                            : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_ip_address') }}
                        </option
                      >
                      <option
                        value="country"
                        :disabled="
                          localModel.matchfields.includes('country') ? true : false
                        "
                        >
                        {{ $t('frontend_groovemail_contacts_step2_ip_country') }}
                        </option
                      >
                    </select>
                  </td>
                  <!-- <p>{{test_contacts.records[`${record_index}`][index].id}}</p> -->
                  <!-- :value="test_contacts.records[`${record_index}`][index].id" -->
                </tr>
              </tbody>

            </table>
          </div>
        </div>
        <div class="flex mt-4 gm-import-mapping__pager">
          <div class="w-full float-right">
            <div class="flex gm-import-mapping__pager-actions">
              <div class="w-1/2 gm-import-mapping__pager-side">
                <div v-if="this.base_index > 0">
                  <gd-button
                    variant="primary"
                    class="w-40 ml-4 gm-import-mapping__pager-button"
                    @click="previous_records()"
                    >
                    {{ $t('frontend_groovemail_contacts_step2_previous_record') }}
                    </gd-button
                  >
                </div>
              </div>
              <div class="w-1/2 gm-import-mapping__pager-side">
                <div v-if="this.base_index < this.localModel.created_contacts.length - 1" class="gm-import-mapping__pager-next">
                <gd-button
                  variant="primary"
                  class="float-right w-40 mr-4 gm-import-mapping__pager-button"
                  @click="next_records()"
                  > {{ $t('frontend_groovemail_contacts_step2_next_record') }} </gd-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Swal from 'sweetalert2';
import themeConfig from '@/theme/themeConfig.js';
import {
  required,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators';
export default {
  middleware: 'auth',
  name: 'step2',
  props: {
    model: {
      required: true
    }
  },
  data() {
    return {
      localModel: this.model,
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      base_index: 0,
      record_index: 0,
    };
  },
  validations: {
    localModel: {
    }
  },
  methods: {
    validate() {
      var isValid = (this.localModel.matchfields.length === this.localModel.totalfields && this.localModel.totalfields > 0) ? true : false;
      this.$emit('on-validate', isValid);
      return isValid;
    },
    onChange(event, id) {
      if (event.target.value === 'Ignore' && event.target.value === '') {
        if (event.target.value === 'Ignore') {
          var index = this.localModel.matchfields.indexOf(event.target.oldvalue);
          if (index > -1) {
            this.localModel.matchfields.splice(index, 1);
          } else {
            this.localModel.matchfields.push(event.target.value);
          }

          var index = this.contact_map_fields.indexOf(
            `${id + ':' + event.target.value}`
          );
          if (index > -1) {
            this.contact_map_fields.splice(index, 1);
          }
        }
      } else {
        //this.contact_map_fields.push(`${id +":"+ event.target.value}`);

        var index = this.localModel.matchfields.indexOf(event.target.oldvalue);
        if (index > -1) {
          this.localModel.matchfields.splice(id, 1, event.target.value);
        } else {
          this.localModel.matchfields.push(event.target.value);
        }
      }
    },
    next_records() {
      this.base_index++;
    },
    previous_records() {
      this.base_index--;
    },
    onFocus: function(event) {
      event.target.oldvalue = event.target.value;
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
  async created() {
    //this.localModel.matchfields = [];
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    }
  }
};
</script>

<style scoped>
.gm-import-mapping__surface {
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
  overflow: hidden;
}

.gm-import-mapping__header {
  border-color: var(--gs-border);
}

.gm-import-mapping__table {
  border-collapse: separate;
  border-spacing: 0;
}

.gm-import-mapping__column-heading {
  background: var(--gs-surface-subtle);
  border-bottom: 1px solid var(--gs-border);
  color: var(--gs-muted-foreground);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.75rem 2rem;
  text-align: left;
  text-transform: uppercase;
}

.gm-import-mapping__row:last-child .gm-import-mapping__value-cell,
.gm-import-mapping__row:last-child .gm-import-mapping__control-cell {
  border-bottom: 0;
}

.gm-import-mapping__value-cell,
.gm-import-mapping__control-cell {
  border-color: var(--gs-border);
}

.gm-import-mapping__value {
  line-height: 1.5;
  margin-bottom: 0;
  margin-right: 1rem;
  margin-top: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.gm-import-mapping__control-label {
  height: 1px;
  margin: -1px;
  overflow: hidden;
  position: absolute;
  width: 1px;
}

.gm-import-mapping__select {
  background: var(--gs-input);
  border-color: var(--gs-border-strong);
  color: var(--gs-foreground);
  min-width: 0;
}

.gm-import-mapping__select:focus-visible {
  border-color: var(--gs-active-border);
  box-shadow: 0 0 0 3px var(--gs-ring);
  outline: 2px solid var(--gs-active);
  outline-offset: 2px;
}

.gm-import-mapping__pager {
  padding: 0 1rem 1rem;
}

.gm-import-mapping__pager-button {
  min-height: 2.75rem;
}

@media (max-width: 639px) {
  .gm-import-mapping__surface {
    border-radius: var(--gs-radius-md);
  }

  .gm-import-mapping__header {
    padding: 1rem;
  }

  .gm-import-mapping__table,
  .gm-import-mapping__table tbody,
  .gm-import-mapping__table tr,
  .gm-import-mapping__table td {
    display: block;
    width: 100%;
  }

  .gm-import-mapping__table-head {
    height: 1px;
    margin: -1px;
    overflow: hidden;
    position: absolute;
    width: 1px;
  }

  .gm-import-mapping__row {
    border-bottom: 1px solid var(--gs-border);
    padding: 1rem;
  }

  .gm-import-mapping__row:last-child {
    border-bottom: 0;
  }

  .gm-import-mapping__value-cell,
  .gm-import-mapping__control-cell {
    border: 0;
    padding: 0;
  }

  .gm-import-mapping__value {
    margin-left: 0;
    margin-right: 0;
  }

  .gm-import-mapping__control-cell {
    margin-top: 0.75rem;
  }

  .gm-import-mapping__control-label {
    color: var(--gs-muted-foreground);
    font-size: 0.75rem;
    font-weight: 700;
    height: auto;
    letter-spacing: 0.04em;
    margin: 0 0 0.375rem;
    overflow: visible;
    position: static;
    text-transform: uppercase;
    width: auto;
  }

  .gm-import-mapping__select {
    height: 2.75rem;
  }

  .gm-import-mapping__pager {
    padding: 0 1rem 1rem;
  }

  .gm-import-mapping__pager-actions {
    flex-direction: column;
    gap: 0.75rem;
  }

  .gm-import-mapping__pager-side,
  .gm-import-mapping__pager-next {
    width: 100%;
  }

  .gm-import-mapping__pager-button {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
}
</style>
